import React from "react";
import { CardsContainer, StatsContainer } from "./Stats.styled";
import Card from "./Card/Card";
import { useTranslation } from "react-i18next";

const Stats = () => {
  const { t } = useTranslation();

  const cardsData = [
    {
      number: "ourWorkPage.stats.number1",
      text: "ourWorkPage.stats.text1",
      bgColor: "lightLavender",
    },
    {
      number: "ourWorkPage.stats.number2",
      text: "ourWorkPage.stats.text2",
      bgColor: "softBlue",
    },
    {
      number: "ourWorkPage.stats.number3",
      text: "ourWorkPage.stats.text3",
      bgColor: "pureWhite",
    },
    {
      number: "ourWorkPage.stats.number4",
      text: "ourWorkPage.stats.text4",
      bgColor: "paleYellow",
    },
  ];

  return (
    <StatsContainer>
      <CardsContainer>
        {cardsData.map((item, index) => (
          <Card
            key={index}
            number={t(item.number)}
            text={t(item.text)}
            bgColor={item.bgColor}
          />
        ))}
      </CardsContainer>
    </StatsContainer>
  );
};
Stats.propTypes = {};
export default Stats;
